import { http } from 'http';

export default {
  deleteTemplate: data =>
    http.delete(`/cms/${data.locale}/templates/${data.templateName}`, {
      headers: {
        appId: data.appId,
        partnerId: data.partnerId || 0
      }
    }),
  deletePattern: data =>
    http.delete(`/cms/${data.locale}/templates/${data.templateName}/patterns/${data.patternName}`, {
      headers: {
        appId: data.appId,
        partnerId: data.partnerId || 0
      }
    }),
  deleteElement: data =>
    http.delete(
      `/cms/${data.locale}/templates/${data.templateName}/patterns/${data.patternName}/elements/${data.elementName}`,
      {
        headers: {
          appId: data.appId,
          partnerId: data.partnerId || 0
        }
      }
    )
};
